<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- START Teams w/ 4 cards in a row w/ image & name & function -->
<section style="{style(block)}">
  <div class="container">
    <div class="row">
      <div class="col-md-8 mx-auto text-center">
        <h6 class="text-warning">{text(block, 'subheadline')}</h6>
        <h2>{text(block, 'headline')}</h2>
      </div>
    </div>
    <div class="row mt-md-5 mt-4">
      {#each blocklist(block, 'cards') as item}
      <div class="col-lg-3 col-6 mb-4">
        <div class="card card-profile card-plain">
          <div class="card-body text-center bg-white shadow-lg border-radius-lg p-3">
            <img class="w-100 border-radius-md" src="{image(item, 'picture', ['_', 300])}">
            <h5 class="mt-3 mb-1 d-md-block d-none">{text(item, 'firstLine')}</h5>
            <p class="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">{text(item, 'secondLine')}</p>
            <p class="mb-0 text-xs font-weight-bolder text-warning text-uppercase">{text(item, 'secondLine')}</p>
          </div>
        </div>
      </div>
      {/each}
    </div>
  </div>
</section>
<!-- END Teams w/ 4 cards w/ image on left & descriptio/social link on right -->

